import { useSmartFormGlobal } from '@workspace/core-ts/contexts';

export const useAvenant = () => {
  const methods = useSmartFormGlobal();
  return methods.watch('DemandeTarif.ActeGestion') === 'AV';
};

export const useLoiHamon = () => {
    const methods = useSmartFormGlobal();
    const devisHamon = methods.watch('DemandeContrat.DevisHamon');

    return devisHamon === true || devisHamon === '1';
};

// Apporteurs (IdApporteur1) autorisés à collecter le consentement de contact (email et téléphone)
export const CONTACT_CONSENT_APPORTEURS = [43397, 479846, 111619, 479835, 100122, 1069018];

export const useSource = () => {
  const methods = useSmartFormGlobal();
  const source = methods.watch('source');
  const apporteur1Belair = methods.watch('DemandeTarif.Police.IdApporteur1');

  return {
    isDirect: source === 'site',
    isAprilMoto: apporteur1Belair === 43397,
    isConcessionnaire: source === 'concessionnaire',
    isCourtier: source === 'courtier' || (source === 'conseiller' && apporteur1Belair !== 43397),
    isConseiller: source === 'conseiller',
    isComparateur: source === 'comparateur',
    canAskContactConsent: CONTACT_CONSENT_APPORTEURS.includes(Number(apporteur1Belair)),
    source,
  };
};
